import format from 'date-fns/format'

// valid formats for date-fns
// https://date-fns.org/v2.29.3/docs/format
// example formats
// 'HH:mma, D MMM'
// 'hh:mmA. D MMM, YYYY'
// 'HH:mm:ss, D MMM YYYY'
// 'hh:mm A, MMM D, YYYY'
// 'hh:mm:ss A, MMMM D, YYYY'
// 'HH:mm:ss.SSS, D MMM YYYY'
// 'YYYY/MM/DD HH:mm:ss'
// 'D MMM YYYY, hh:mm A'
// 'dddd, MMMM D YYYY, HH:mm'
// 'ddd MMM D YYYY, HH:mm:ss A'

export const formatTimestamp = (dt: string | Date, customFormat?: string) => {
  const defaultFormat = 'HH:mma, D MMM'
  return format(dt, customFormat || defaultFormat)
}

export default formatTimestamp
